import { render, staticRenderFns } from "./SettingsFeatures.vue?vue&type=template&id=21c4e41e&scoped=true"
import script from "./SettingsFeatures.vue?vue&type=script&lang=js"
export * from "./SettingsFeatures.vue?vue&type=script&lang=js"
import style0 from "./SettingsFeatures.vue?vue&type=style&index=0&id=21c4e41e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c4e41e",
  null
  
)

export default component.exports